import * as React from "react";
import { BusinessServiceDescriptor } from "src/businessServices";
import { loadSample2Settings, saveSample2Settings } from "./apiSample2";
import { zSample2Settings } from "./ZSample2Settings";
import { Sample2Settings } from "./Sample2Settings";
import { Sample2View } from "./Sample2View";

export const bsSample2: BusinessServiceDescriptor = {
  key: "Sample v2",
  viewer: (_info, data) => <Sample2View entityId={data.entity?.id} />,
  renderSettings: (_info, store) => {
    const { curNode } = store;
    if (curNode?.type === "obj") {
      const { attrList } = curNode;
      return <Sample2Settings attrList={attrList ?? []} />;
    }
    return null;
  },
  loadSettings: async (info) => loadSample2Settings(info.objectId),
  async saveSettings(info, values) {
    const { objectId, id } = info;
    const settings = zSample2Settings.parse(values);
    await saveSample2Settings(objectId, id, settings);
  },
};
